import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../api';
import toast from 'react-hot-toast';
import { setPriceCodeSettings } from '../utils/priceCode';

const GoogleAuthSuccess = () => {
  const navigate = useNavigate();
  const [shopName, setShopName] = useState('');
  const [needsShopName, setNeedsShopName] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const user = params.get('user');
    const needsShop = params.get('needsShopName') === 'true';

    if (token && user) {
      const userData = JSON.parse(decodeURIComponent(user));
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(userData));

      if (needsShop) {
        setNeedsShopName(true);
        setLoading(false);
      } else {
        loadProfileAndRedirect();
      }
    } else {
      navigate('/');
    }
  }, []);

  const loadProfileAndRedirect = async () => {
    try {
      const profileRes = await API.get('/auth/profile');
      localStorage.setItem('shopProfile', JSON.stringify(profileRes.data));
      setPriceCodeSettings(
        profileRes.data.price_code_enabled || false,
        profileRes.data.price_code_data?.digit_map || {},
        profileRes.data.price_code_data?.zero_letters || ['', ''],
        profileRes.data.price_code_data?.repeat_letter || ''
      );
    } catch (err) {
      console.error(err);
    }
    navigate('/dashboard');
  };

  const handleShopNameSubmit = async (e) => {
    e.preventDefault();
    if (!shopName.trim()) {
      toast.error('Please enter your shop name');
      return;
    }
    try {
      await API.put('/auth/profile', { shop_name: shopName });
      const user = JSON.parse(localStorage.getItem('user'));
      localStorage.setItem('user', JSON.stringify({ ...user, shop_name: shopName }));
      await loadProfileAndRedirect();
    } catch (err) {
      toast.error('Failed to save shop name');
    }
  };

  if (loading) {
    return (
      <div style={styles.container} className="container">
        <div style={styles.card}>
          <p>Setting up your account...</p>
        </div>
      </div>
    );
  }

  if (needsShopName) {
    return (
      <div style={styles.container} className="container">
        <div style={styles.card}>
          <h2 style={styles.title}>One more step! 🏪</h2>
          <p style={styles.subtitle}>Please enter your shop name to complete setup</p>
          <form onSubmit={handleShopNameSubmit}>
            <input
              style={styles.input}
              type="text"
              placeholder="Your Shop Name"
              value={shopName}
              onChange={(e) => setShopName(e.target.value)}
              required
              autoFocus
            />
            <button style={styles.button} type="submit">
              Complete Setup
            </button>
          </form>
        </div>
      </div>
    );
  }

  return null;
};

const styles = {
  container: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f0f2f5' },
  card: { background: '#fff', padding: '2rem', borderRadius: '12px', width: '100%', maxWidth: '400px', boxShadow: '0 2px 12px rgba(0,0,0,0.1)', textAlign: 'center' },
  title: { margin: '0 0 0.5rem', fontSize: '24px' },
  subtitle: { color: '#888', marginBottom: '1.5rem' },
  input: { width: '100%', padding: '10px', marginBottom: '1rem', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box' },
  button: { width: '100%', padding: '10px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '16px', cursor: 'pointer' },
};

export default GoogleAuthSuccess;